import { render } from "./DashboardNavbar.vue?vue&type=template&id=0cd59870"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=0cd59870&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/pinenativeWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__